<template >
  <div   class="td-cell-bg">
    <span style="background-color:#DCC2E9" v-if="this.riskLevel===9"><em style="color:#333333">需要翻译</em></span>
    <span style="background-color:#e22b00" v-else-if="this.riskLevel===3"><em
      style="color:#FFFFFF">风险3级</em></span>
    <span style="background-color:#ffa200" v-else-if="this.riskLevel===2"><em
      style="color:#FFFFFF">风险2级</em></span>
    <span style="background-color:#fff046" v-else-if="this.riskLevel===1"><em
      style="color:#333333">风险1级</em></span>
    <span style="background-color:#0dc84f" v-else-if="this.riskLevel===0"><em style="color: #FFFFFF">风险0级</em></span>
    <span style="background-color:#ffa200" v-else-if="this.riskLevel===10"><em
      style="color:#FFFFFF">机翻直出</em></span>
    <span style="background-color:#DCC2E9" v-if="this.riskLevel===99"><em style="color:#333333">例句填充</em></span>
  </div>

</template>

<script>

export default {
  props: ['riskLevel'],
  data() {
    return {}
  },
}

</script>

